import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../../types/api-response";
import axios from "../../../utils/axiosInceptor";
import { apiV1Endpoint } from "../endpoints";
import { Organization } from "./types";
import { getLoginResponse } from "../../../utils/getLoginResponse";
import { AxiosRequestConfig } from "axios";

const getOrganization = async (orgId: string, params?: AxiosRequestConfig["params"]) => {
  const url = `${apiV1Endpoint}/organization/${orgId}`;
  const response = await axios.get<ApiResponse<Organization>>(url, { params });
  return response.data.result;
};

export type UseGetOrganizationOptions = {
  params?: AxiosRequestConfig["params"];
  isEnabled?: boolean;
};

export const useGetOrganization = (options: UseGetOrganizationOptions = {}) => {
  const { params, isEnabled = true } = options;

  const { orgId } = getLoginResponse();

  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["organization", orgId, params],
    queryFn: () => getOrganization(orgId, params),
    enabled: Boolean(orgId) && isEnabled,
    staleTime: 5 * 60 * 1000, // cache for 5 minutes
    refetchOnWindowFocus: false,
  });

  return {
    organization: data,
    isLoadingOrganization: isLoading,
    isSuccessOrganization: isSuccess,
  };
};
